<app-header-one [class]="'header-gym'" [themeLogo]="themeLogo"></app-header-one>
<section class="page-header">
    <h1>I tuoi Ristoranti</h1>
</section>
<!-- section start -->
<section class="section-b-space section-list-rest margin-header-big">
    <div class="collection-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <section class="search-block">
                        <div class="container">
                          <div class="row">
                            <div class="col-sm-10  offset-lg-1">
                                <div class="d-flex">
                                <div class="form-header flex-grow-1 ">
                                    <button  class="btn btn-primary"><i class="fa fa-search"></i></button>
                                <div class="form-group mb-0">
                                  <input type="text" [(ngModel)]="search" class="form-control" id="exampleInputPassword1" placeholder="Cerca Ristorante">
                                </div>
                                
                            </div>
                                <button  class="btn eit-filter"><img src="https://assets.eatintime.it/imgs/filtri.png"/></button>
                            </div>
                        </div>
                          </div>
                        </div>
                      </section>
                </div>
                <div class="col-sm-10 align-self-center" style="margin: auto;">
                    <ngx-horizontal-scroll-cat (notifyCat)="onNotify($event)" [items]="categories" ></ngx-horizontal-scroll-cat>
                </div>
            </div>
            <div class="row">
                <div class="collection-content col">
                    <div class="page-main-content">
                        <div class="row">
                            <div class="col-sm-10 col-xs-12 align-self-center" style="margin: auto;">

                                <div class="collection-product-wrapper" id="products">
                               
                                    <div class="product-wrapper-grid grid-view">
                                        <div class="row">
                                            <div class="col-grid-box col-xl-3 col-md-6" 
                                                *ngFor="let restaurant of recordsFiltered | filterref:search">
                                                <div class="product-box">
                                                   <app-restaurant-box [restaurant]="restaurant" [thumbnail]="false"
                                                        [cartModal]="true" [loader]="true">
                                                        </app-restaurant-box>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- section End -->
<app-footer-two [class]="'bg-img-gym bg-size'" [themeLogo]="themeLogo"></app-footer-two>